import React, { useState } from 'react';
import { Badge, Button } from '../../components/UI';
import CostBox from './CostBox';
import EditPanel from './EditPanel';
import { SKIP_REASONS } from './marketingFormat';
import styles from './Marketing.module.css';

const CONTENT_EDIT_FIELDS = [
  { key: 'hook_nl', label: 'Hook (NL)' }, { key: 'script_nl', label: 'Script (NL)', multiline: true },
  { key: 'caption_nl', label: 'Caption (NL)', multiline: true }, { key: 'cta', label: 'Closing card (NL)' },
  { key: 'on_screen_text', label: 'On screen (NL)', list: true },
  { key: 'hook_en', label: 'Hook (EN)' }, { key: 'script_en', label: 'Script (EN)', multiline: true },
  { key: 'caption_en', label: 'Caption (EN)', multiline: true }, { key: 'cta_en', label: 'Closing card (EN)' },
  { key: 'on_screen_text_en', label: 'On screen (EN)', list: true }, { key: 'hashtags', label: 'Hashtags', list: true },
];

const Field = ({ label, value }) => {
  if (!value || (Array.isArray(value) && value.length === 0)) return null;
  return (
    <div className={styles.field}>
      <div className={styles.fieldLabel}>{label}</div>
      <div className={styles.fieldValue}>{Array.isArray(value) ? value.join(' · ') : value}</div>
    </div>
  );
};

const QueueCard = ({ item, monthSpentUsd, settings, onApprove, onSkip, onEdit, busy }) => {
  const [lang, setLang] = useState('nl');
  const [skipping, setSkipping] = useState(false);
  const [editing, setEditing] = useState(false);
  const d = item.draft || {};
  const nl = lang === 'nl';
  const open = item.status === 'pending_approval' || item.status === 'flagged';

  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <span className={styles.cardType}>CONTENT · {item.slot?.pillar} · {item.slot?.format}</span>
        <span>
          {item.warnings?.length > 0 && <Badge variant="warning">⚑ {item.warnings.length} warning{item.warnings.length > 1 ? 's' : ''}</Badge>}{' '}
          {item.draft?.risk_flag && item.draft.risk_flag !== 'none' && <Badge variant="danger">{item.draft.risk_flag}</Badge>}{' '}
          {!open && <Badge variant="secondary">{item.status}</Badge>}
        </span>
      </div>

      {item.problems?.length > 0 && (
        <ul className={styles.problems}>
          {item.problems.map((p) => <li key={p}>{p}</li>)}
        </ul>
      )}

      {editing ? (
        <EditPanel fields={CONTENT_EDIT_FIELDS} draft={d} busy={busy}
          onCancel={() => setEditing(false)}
          onSave={async (fields) => { if (await onEdit(item, fields)) setEditing(false); }} />
      ) : item.draft && (
        <>
          <div className={styles.langToggle}>
            <button type="button" className={nl ? styles.langActive : ''} onClick={() => setLang('nl')}>NL</button>
            <button type="button" className={!nl ? styles.langActive : ''} onClick={() => setLang('en')}>EN</button>
          </div>
          <Field label="Hook" value={nl ? d.hook_nl : d.hook_en} />
          <Field label="Script" value={nl ? d.script_nl : d.script_en} />
          <Field label="On screen" value={nl ? d.on_screen_text : d.on_screen_text_en} />
          <Field label="Caption" value={nl ? d.caption_nl : d.caption_en} />
          <Field label="Closing card" value={nl ? d.cta : d.cta_en} />
          <Field label="Hashtags" value={d.hashtags} />
          <Field label="What to film" value={d.shot_list} />
        </>
      )}

      {item.warnings?.length > 0 && (
        <ul className={styles.warnings}>
          {item.warnings.map((w, i) => <li key={i}><strong>{w.rule}</strong> — {w.note}</li>)}
        </ul>
      )}

      <div className={styles.cardFooter}>
        <CostBox cost={item.cost} monthSpentUsd={monthSpentUsd} settings={settings} />
        {open && !editing && (
          <div className={styles.actions}>
            <Button onClick={() => onApprove(item)} disabled={item.status === 'flagged' || busy} loading={busy}>Approve</Button>
            {item.draft && <Button variant="outline" onClick={() => setEditing(true)} disabled={busy}>Edit</Button>}
            {!skipping && <Button variant="outline" onClick={() => setSkipping(true)} disabled={busy}>Skip</Button>}
            {skipping && SKIP_REASONS.map((r) => (
              <Button key={r} size="sm" variant="ghost" disabled={busy} onClick={() => onSkip(item, r)}>{r}</Button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default QueueCard;
